export const findProductPhotoReference = (product, country, url) => {
  if (!product?.id || !country) return null;
  const ref = photo => ({ country, productId: product.id, photo });
  if (String(product.image || '').trim() === url) return ref({ kind: 'main' });
  const album = (product.photos || []).findIndex(p => String(typeof p === 'string' ? p : p?.url || '').trim() === url);
  if (album >= 0) return ref({ kind: 'album', index: album });
  const style = (product.styleDetails || []).findIndex(p => String(p?.image || '').trim() === url);
  return style >= 0 ? ref({ kind: 'style', index: style }) : null;
};
